import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader } from "@/components/Loader";

export default function GradingPage() {
  const [queue, setQueue] = useState(null);
  const [grades, setGrades] = useState({});

  const load = () => api.get("/admin/grading").then((r) => setQueue(r.data.queue)).catch((e) => toast.error(apiError(e)));
  useEffect(() => { load(); }, []);

  const setGrade = (resultId, qId, val) => setGrades({ ...grades, [`${resultId}:${qId}`]: val });

  const finalize = async (item) => {
    const payload = {
      grades: item.short_answers.map((sa) => ({
        question_id: sa.question_id,
        awarded: Math.min(sa.points, Math.max(0, Number(grades[`${item.result_id}:${sa.question_id}`] ?? 0))),
      })),
    };
    try { await api.post(`/admin/results/${item.result_id}/grade`, payload); toast.success("Graded & finalized"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  if (!queue) return <Loader />;

  return (
    <div className="space-y-6" data-testid="admin-grading">
      <h1 className="text-[32px] font-bold text-[#1c1b1b]">Short-Answer Grading</h1>
      {queue.length === 0 ? (
        <p className="text-sm text-[#434654] bg-white border border-[#E5E7EB] rounded-lg p-6" data-testid="grading-empty">Nothing awaiting grading.</p>
      ) : (
        <div className="space-y-4">
          {queue.map((item) => (
            <div key={item.result_id} data-testid={`grading-item-${item.result_id}`} className="bg-white border border-[#E5E7EB] rounded-lg p-6">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <p className="font-semibold text-[#1c1b1b]">{item.nurse_name} · {item.module_title}</p>
                  <p className="text-xs text-[#434654]">Attempt {item.attempt_number} · Auto score {item.auto_earned}/{item.total_points} pts</p>
                </div>
              </div>
              <div className="space-y-4">
                {item.short_answers.map((sa) => (
                  <div key={sa.question_id} className="border border-[#E5E7EB] rounded-lg p-4">
                    <p className="font-medium text-[#1c1b1b] mb-1">{sa.question}</p>
                    <p className="text-sm text-[#434654] bg-[#fcf9f8] rounded p-3 mb-2">{sa.your_text || "(no answer)"}</p>
                    {sa.explanation && <p className="text-xs text-[#434654] mb-2">Model answer: {sa.explanation}</p>}
                    <div className="flex items-center gap-2">
                      <label className="text-sm text-[#434654]">Award points (max {sa.points}):</label>
                      <input data-testid={`grade-input-${item.result_id}-${sa.question_id}`} type="number" min={0} max={sa.points}
                        value={grades[`${item.result_id}:${sa.question_id}`] ?? ""} onChange={(e) => setGrade(item.result_id, sa.question_id, e.target.value)}
                        className="h-10 w-24 rounded-lg border border-[#E5E7EB] px-3 focus:outline-none focus:ring-2 focus:ring-[#003d9b]" />
                    </div>
                  </div>
                ))}
              </div>
              <button data-testid={`finalize-grade-${item.result_id}`} onClick={() => finalize(item)}
                className="mt-4 h-11 px-5 rounded-lg bg-[#003d9b] text-white font-semibold hover:bg-[#0052cc] transition-colors">Finalize Score</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
